import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

import { FullComponent } from './layouts/full/full.component';
import { AuthGuard } from './guards/auth.guard';
import { LoginComponent } from './login/login.component';
import { RegisterComponent } from './register/register.component';
import { ForgotComponent } from './forgot/forgot.component';
import { ConfirmaInvitacionComponent } from './confirma-invitacion/confirma-invitacion.component';

export const routes: Routes = [
  {
    path: '',
    component: FullComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: '',
        loadChildren: './starter/starter.module#StarterModule'
      },
      {
        path: 'users',
        loadChildren: './users/users.module#UsersModule'
      },
      {
        path: 'roles',
        loadChildren: './roles/roles.module#RolesModule'
      },
      {
        path: 'configurations',
        loadChildren: './configuraciones/configuraciones.module#ConfiguracionesModule'
      },
      {
        path: 'locals',
        loadChildren: './locals/locals.module#LocalsModule'
      },
      {
        path: 'eventos',
        loadChildren: './events/events.module#EventsModule'
      },
      {
        path: 'localmenu',
        loadChildren: './cartacategorias/cartacategorias.module#CartacategoriasModule'
      },
      {
        path: 'alergenos',
        loadChildren: './alergenos/alergenos.module#AlergenosModule'
      },
      {
        path: 'stats',
        loadChildren: './stats/stats.module#StatsModule'
      },
      {
        path: 'promotions',
        loadChildren: './promos/promos.module#PromosModule'
      },
      {
        path: 'mypromos',
        loadChildren: './mypromos/mypromos.module#MypromosModule'
      },
      {
        path: 'customers',
        loadChildren: './customers/customers.module#CustomersModule'
      },
      {
        path: 'groupscustomers',
        loadChildren: './groupscustomers/groupscustomers.module#GroupsCustomersModule'
      },
      {
        path: 'invitaciones',
        loadChildren: './invitaciones/invitaciones.module#InvitacionesModule'
      },
      {
        path: 'languages',
        loadChildren: './idiomas/idiomas.module#IdiomasModule'
      },
      {
        path: 'categorias',
        loadChildren: './categorias/categorias.module#CategoriasModule'
      },
      {
        path: 'categoriasayuda',
        loadChildren: './categoriasayuda/categoriasayuda.module#CategoriasayudaModule'
      },
      {
        path: 'preferences',
        loadChildren: './preferences/preferences.module#PreferencesModule'
      },
      {
        path: 'estadosolicitudes',
        loadChildren: './estadosolicitudes/estadosolicitudes.module#EstadoSolicitudesModule'
      },
      {
        path: 'cartadigital',
        loadChildren: './cartas/cartas.module#CartasModule'
      },
      {
        path: 'questions',
        loadChildren: './questions/questions.module#QuestionsModule'
      },
      {
        path: 'profile',
        loadChildren: './profile/profile.module#ProfileModule'
      },
      {
        path: 'patrocinadores',
        loadChildren: './patrocinadores/patrocinadores.module#PatrocinadoresModule'
      },
      {
        path: 'patrocinadores-rutas',
        loadChildren: './patrocinadores-rutas/patrocinadores-rutas.module#PatrocinadoresRutasModule'
      },
      {
        path: 'cupones',
        loadChildren: './cupones/cupones.module#CuponesModule'
      },
      {
        path: 'helpcenter',
        loadChildren: './videos/videos.module#VideosModule'
      },
      {
        path: 'tiposoportes',
        loadChildren: './tiposoportes/tiposoportes.module#TiposoportesModule'
      },
      {
        path: 'promotipos',
        loadChildren: './tipospromos/tipospromos.module#TipoPromosModule'
      },
      {
        path: 'soportes',
        loadChildren: './soportes/soportes.module#SoportesModule'
      },
      {
        path: 'publicadmon',
        loadChildren: './administrations/administrations.module#AdministrationsModule'
      },
      {
        path: 'distritos',
        loadChildren: './distritos/distritos.module#DistritosModule'
      },
      {
        path: 'puntosinformacion',
        loadChildren: './puntosinformacion/puntosinformacion.module#PuntosInformacionModule'
      },
      {
        path: 'caracteristicas',
        loadChildren: './caracteristicaslocales/caracteristicaslocales.module#CaracteristicasModule'
      },
      {
        path: 'textoslegales',
        loadChildren: './textoslegales/textoslegales.module#TextosLegalesModule'
      },
      {
        path: 'tareas',
        loadChildren: './tareas/tareas.module#TareasModule'
      },
      {
        path: 'pages',
        loadChildren: './pages/pages.module#PagesModule'
      },
      {
        path: 'gestorerrores',
        loadChildren: './gestorerrores/gestorerrores.module#GestorErroresModule'
      },
      {
        path: 'usersdemo',
        loadChildren: './usersdemo/usersdemo.module#UsersDemoModule'
      },
      {
        path: 'usersstaffs',
        loadChildren: './usersstaffs/usersstaffs.module#UsersStaffsModule'
      },
      {
        path: 'routes',
        loadChildren: './rutas/rutas.module#RutasModule'
      },
      {
        path: 'encuestas',
        loadChildren: './encuestas/encuesta.module#EncuestaModule'
      },
      {
        path: 'editores',
        loadChildren: './rutaseditores/rutas-editor.module#RutaEditorModule'
      },
    ]
  },
  {
    path: 'login',
    component: LoginComponent,
  },
  {
    path: 'confirmacion-evento/:id',
    component: ConfirmaInvitacionComponent,
  },
  {
    path: 'forgot',
    component: ForgotComponent,
  },
  {
    path: 'register',
    component: RegisterComponent,
  },
  {
    path: '**',
    redirectTo: ''
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes), NgbModule.forRoot()],
  exports: [RouterModule]
})
export class AppRoutingModule {}
